export var INIT_CUSTOM_WIDGET = 'INIT_CUSTOM_WIDGET';
export var SET_CUSTOM_WIDGET_HEIGHT = 'SET_CUSTOM_WIDGET_HEIGHT';
export var SET_CUSTOM_WIDGET_IS_EXPANDED = 'SET_CUSTOM_WIDGET_IS_EXPANDED';
export var SET_CUSTOM_WIDGET_STATUS = 'SET_CUSTOM_WIDGET_STATUS';
export var initCustomWidget = function initCustomWidget(payload) {
  return {
    payload: payload,
    type: INIT_CUSTOM_WIDGET
  };
};
export var setCustomWidgetHeight = function setCustomWidgetHeight(payload) {
  return {
    payload: payload,
    type: SET_CUSTOM_WIDGET_HEIGHT
  };
};
export var setCustomWidgetIsExpanded = function setCustomWidgetIsExpanded(payload) {
  return {
    payload: payload,
    type: SET_CUSTOM_WIDGET_IS_EXPANDED
  };
};
export var setCustomWidgetStatus = function setCustomWidgetStatus(payload) {
  return {
    payload: payload,
    type: SET_CUSTOM_WIDGET_STATUS
  };
};